import { useEffect } from 'react';

import { useRouter } from 'next/compat/router';
import { usePathname } from 'next/navigation';

import {
  userStoreSelector,
  useUserStore,
} from '@repo/editor/src/stores/userStore';
import { useIntercom } from 'react-use-intercom';

export const INTERCOM_APP_ID = 'x4uvl81w';

const INTERCOM_SHOW_PARAM = 'gs_open_chat';

export const setIntercomLauncherVisibility = (
  visibility: 'hidden' | 'visible'
): void => {
  document?.body?.classList.toggle(
    'hide-intercom-launcher',
    visibility === 'hidden'
  );
};

export const useIntercomOpenOnQueryParam = (): void => {
  const { show } = useIntercom();

  const user = useUserStore(userStoreSelector.loadingUser);

  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    // TODO(App Router): remove router check after moving to app router and add useSearchParams instead of window.location.search
    if (user === false || !router || !router.isReady) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get(INTERCOM_SHOW_PARAM)) {
      // Intercom needs time to boot.
      setTimeout(show, 250);

      urlParams.delete(INTERCOM_SHOW_PARAM);

      void router.replace(
        {
          pathname,
          query: urlParams.toString(),
        },
        undefined,
        { shallow: true }
      );
    }
  }, [user, pathname, show, router]);
};
